import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { FlowDto } from '@/types/dtos/flows/response/flow.dto.ts';
import type { CreateEventFlowDto } from '@/types/dtos/flows/request/create-event-flow.dto.ts';
import { GET_EVENT_FLOWS_QUERY_KEY } from '../../queries/flows/use-get-event-flows.ts';
import { GET_EVENT_QUERY_KEY } from '../../queries/events/use-get-event.ts';
import { invalidatePublicationStateQueries } from '@/state/queries/events/use-publication-state';

export const useCreateEventFlowMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (newFlow: CreateEventFlowDto) => {
      const token = await getToken();
      return createEventFlow(newFlow, token ?? '');
    },
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries({
          queryKey: [GET_EVENT_FLOWS_QUERY_KEY],
        }),
        queryClient.invalidateQueries({
          queryKey: [GET_EVENT_QUERY_KEY],
        }),
        invalidatePublicationStateQueries(queryClient),
      ]);
    },
  });
};

const createEventFlow = async (newFlow: CreateEventFlowDto, token: string): Promise<FlowDto> => {
  const { eventId, flow } = newFlow;
  const url = `${import.meta.env.VITE_API_URL}/flows/event/${eventId}`;
  return sendJSONRequest({ url, method: METHOD.POST, body: flow, token });
};

export default useCreateEventFlowMutation;
